import { DialogType } from '@tableau/widgets';
import React from 'react';

import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { Messages } from '~src/codegen/Localize';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { CreateLocalUserIdentityDialog } from './CreateLocalUserIdentityDialog';

const ACTION_TESTID = 'create-local-user-identity-action';

export class CreateLocalUserIdentityAction {
  public static readonly instance = new CreateLocalUserIdentityAction();

  public showCreateLocalUserIdentityDialog(identityPool: IIdentityPool, user: IUser, isServerUser: boolean): Promise<any> {
    let modalInstance: ModalInstance;
    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      close: (result: any) => modalInstance && modalInstance.close(result),
      identityPool: identityPool,
      user: user,
      isServerUser: isServerUser
    };

    modalInstance = ReactModalService.open({
      title: Messages.identityPools_AddToPoolAction_DialogTitle(),
      type: DialogType.NormalWithTitleBar,
      dialogContent: React.createElement(CreateLocalUserIdentityDialog, dialogProps),
      testId: ACTION_TESTID,
      showCloseButton: true,
      disableAutoFocus: dialogElement => dialogElement.querySelector('input[placeholder]'),
      dialogWidth: TabDialogWidth.width500px
    });

    return modalInstance.result;
  }
}

export default CreateLocalUserIdentityAction.instance;
